import * as api from "../api/index"
import { FETCH_ALL } from "./../constants/action_types.js"

export const getPosts = (quality) => async (dispatch) =>
{
  try
  {
    
    /**
     * I'm not sure whether I prefer object destructuring
     * or dot notation yet, so I'll probably be using both
     * during this project
     */

    const { data } = await api.fetchPosts(quality);
    dispatch({ type: FETCH_ALL, payload: data });
  }
  catch (err)
  {
    console.trace(err);
  }
}
